import axios from 'axios';
import config from './config';

const urlParams = new URLSearchParams(window.location.search);
const token = urlParams.get('token');

const api = axios.create({
    baseURL: `${config.backendApi}`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
});

api.interceptors.response.use(function (response) {
    if(response.data.code == 403 || response.data.code == 401){
        window.location.hash = "/unauthorized"
    }
    if(response.data.code == 404){
      window.location.hash = "/empty"
  }
    return response.data
  }, function (error) {
    return {
        code: "500",
        data: [],
        message: "Server Error"
    }
  });

export default api;